<template>
    <div class="field__container" :class="{'field__container--no-label': !title || !labelFor, 'field__container--error': errorMessage, 'field__container--mandatory': required}">
        <slot name="input">
            <label class="form__checkbox" :for="name">
                <input type="checkbox"
                        v-model="model"
                        :id="name"
                        :name="name"
                        false-value="null"
                        @change="updateValue"
                        class="form__control form__control--checkbox"
                />
                <span class="checkmark checkmark--checkbox"></span>
                {{ title }}
            </label>
        </slot>
        <slot name="error">
            <div
                    v-if="errorMessage"
                    class="form__error"
            >
                {{ errorMessage }}
            </div>
        </slot>

    </div>
</template>

<script>
    import FieldMixin from '../../mixins/FieldMixin'

    export default {
        name: 'FieldCheckbox',
        mixins: [
            FieldMixin
        ],
        model: {
            prop: 'value',
            event: 'update'
        },
        methods: {
            updateValue(e) {
                if(e.target.checked) {
                    this.$emit('update',true);
                } else {
                    this.$emit('update',null);
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/form/components/fields/FieldCheckbox.vue